<template>
<div>
    <div class="main-search">
        <div class="main-search--container">
            <multiselect v-model="searchValues" :options="searchOptions" :multiple="true" group-values="stack"
                         group-label="label" :group-select="false" track-by="name" label="name" :taggable="true"
                         @tag="addSearchTag" tag-placeholder="Add this as new tag"
              placeholder="Search"></multiselect>
            <button class="btn--search" @click="search">Search</button>
            <button class="btn--clear" @click="clear">clear</button>
        </div>
    </div>
    <div class="main-nav">
        <nav class="nav">
            <ul class="nav-list--main">
                <li>
                    <a href="#" class="active">
                        <span class="icon--group">
                            <span class="icon icon--design"></span>
                            <span class="icon icon--mobile"></span>
                            <span class="icon icon--web"></span>
                        </span>
                        <span class="text">all</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <span class="icon icon--web"></span>
                        <span class="text">web</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <span class="icon icon--mobile"></span>
                        <span class="text">mobile</span>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <span class="icon icon--design"></span>
                        <span class="text">design</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="container-wrapper">
        <div v-for="(item, id) in data" :key="id" class="card">
            <div class="card--content">
                <router-link :to="{ name: 'project_details', params: {slug: item.slug}}" class="card--img">
                    <img :src="item.main_image.thumb1" :alt="item.title" />
                </router-link>
                <div class="card--info">
                    <h5 class="card--title">
                        <router-link :to="{name: 'project_details', params: {slug: item.slug}}">{{item.title}}
                        </router-link>
                    </h5>
                    <div class="card--text" v-if="item.subject">
                        <p>{{item.subject}}</p>
                    </div>
                    <div class="card--links">
                        <ul>
                            <li v-if="item.web_url" class="card--link-web">
                                <a :href="item.web_url" target="_blank">{{item.web_url}}</a>
                            </li>
                            <li v-if="item.app_store_url" class="card--link-apple">
                                <a :href="item.app_store_url" target="_blank">{{item.app_store_url}}</a>
                            </li>
                            <li v-if="item.google_play_url" class="card--link-google">
                                <a :href="item.google_play_url" target="_blank">{{item.google_play_url}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="badge--wrapper">
                        <template v-for="v in item.tags">
                            <router-link :to="{ name: 'portfolio', query: {tag: v}}">
                                <span class="badge">#{{v}}</span>
                            </router-link>
                        </template>
                    </div>
                    <!-- TYPES -->
                    <div class="badge--wrapper">
                        <span class="badge" v-for="v in item.types">#{{v}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading-wrapper">
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler"></infinite-loading>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import Multiselect from 'vue-multiselect';

export default {
    name: "Portfolio",
    components: {
        InfiniteLoading,
        Multiselect
    },
    data() {
        return {
            searchValues: [],
            searchQuery: {},
            searchParams: {
                tags: {},
                technologies: {},
                types: {},
                categories: {}
            },
            infiniteId: +new Date(),
            query: {
                page: 1
            },
        };
    },
    created() {
        this.resetState();
        this.fetchSearchOptions();
        this.checkRoute();
    },
    destroyed() {
        this.resetState()
    },
    computed: {
        ...mapGetters('ProjectsIndex', ['data', 'total', 'loading', 'searchOptions']),
    },
    watch: {
        searchValues(value) {
            this.searchQuery = {};
            const that = this;
            if(value.length) {
                value.forEach(function (item) {
                    const key = item.type;
                    if (!that.searchQuery[key]) {
                        that.searchQuery[key] = [];
                    }
                    that.searchQuery[key].push(item.name);
                });
            }
        },
        '$route.query': function(value) {
            this.query = Object.assign({}, value);
        },
        query: {
            handler(query) {
                this.setQuery(query);
                this.infiniteId += 1;
                this.resetData();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('ProjectsIndex', ['fetchData', 'setQuery', 'resetState', 'resetData', 'fetchSearchOptions',
            'nextPage'
        ]),
        infiniteHandler(stateChanger) {
            this.fetchData().then((data) => {
                if (data.length) {
                    this.nextPage();
                    stateChanger.loaded();
                } else {
                    stateChanger.complete();
                }
            })
        },
        search() {
            this.$router.push({ name: 'portfolio', query: this.searchQuery })
        },
        clear() {
            this.searchValues = [];
            this.$router.push({ name: 'portfolio', query: {} });
        },
        addSearchTag(value) {
            const type = 'keyword';
            const tag = {
                type: type,
                name: value
            };
            this.searchValues.push(tag);
            if (!this.searchQuery[type]) {
                this.searchQuery[type] = [];
            }
            this.searchQuery[type].push(value);
        },
        checkRoute() {
            if(this.$route.params.presentation) {
                this.query = Object.assign({}, this.$route.params);
            } else if(this.$route.query) {
                this.query = Object.assign({}, this.$route.query);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/pages/Portfolio.vue